<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <main class="register">
    <form>
      <img class="img_glow_left" src="/static/images/home/glow.png">
      <section class="reg_1">
        <h1>{{ $_getTranslations.visitor_two_step_registration_send_sms }}</h1>

        <read-only-stepper-header
          :total-steps="2"
          :active-step="1"
        ></read-only-stepper-header>

        <img src="/static/images/register/mobile_img.svg" class="register_mobile" alt="mobile image">

        <p>{{ getTranslations.visitor_sign_up_2_info_msg_unique_code_send }}</p>

        <base-digit-form-input
          v-model="user.pin"
          :label="$_getTranslations.visitor_sign_up_2_validation_code"
          :invalid="hasErrors"
          :max-length="maximumDigitsPinLength"
          :input-type="'password'"
          @keyup="check"
        ></base-digit-form-input>

        <div class="error_text" v-show="getMessage(message) && user.pin">{{ getMessage(message) }}</div>

        <p>{{ $_getTranslations.visitor_sign_up_free_for}}</p>

        <base-button
          :disabled="(hasErrors  || waitForResponse)"
          container-class="continue"
          @button:click.prevent="checkButton"
        >{{ $_getTranslations.visitor_sign_up_1_single_country_continue }}</base-button>

        <p>{{ $_getTranslations.visitor_sign_up_already_have_account }}
          <router-link
            :to="'login'"
            class="text_links login"
          >{{ $_getTranslations.visitor_sign_up_login }}
          </router-link>
        </p>

        <div class="disclaimer">
          {{ $_getTranslations.visitor_sign_up_1_single_country_disclaimer_text }}
        </div>

      </section>
    </form>
  </main>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import IntegrationMixin from '../../../common/mixins/integration';
import ReadOnlyStepperHeader from "../../common/header/ReadOnlyStepperHeader";
import translationMixin from "../../../common/mixins/translation";
import BaseDigitFormInput from "../../common/formInput/BaseDigitFormInput";
import BaseButton from "../../common/button/BaseButton";

export default {
  name: 'two-step-sign-up-1',
  components: {BaseButton, BaseDigitFormInput, ReadOnlyStepperHeader},
  mixins: [IntegrationMixin, translationMixin],
  data() {
    return {
      user: {
        pin: '',
        msisdn: '',
      },
      message: '',
      hasErrors: false,
      blacklistWords: [],
      waitForResponse: false,
    };
  },
  // eslint-disable-next-line
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getHeIntegration(to);
    });
  },
  created() {
    const inputMsisdn = this.$route.query.userMsisdn || this.$route.query.msisdn;
    if (inputMsisdn) this.setRegistrationInfo(inputMsisdn);
  },
  methods: {
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    getHeIntegration(to) {
      this.getIntegrationParametersCheck()(to);
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    check: function check() {
      const validPinRegex = /^[a-zA-Z0-9]{0,10}$/;
      const validPin = this.user.pin.match(validPinRegex);
      if (!validPin) {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    checkButton() {
      if (!this.hasErrors && this.user.pin.length > 0 && !this.hasErrors) {
        this.message = '';
        this.waitForResponse = true;
        this.$axios.get(`api/verifyPin?pin=${this.user.pin}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}`).then((response) => {
          this.waitForResponse = false;
          const res = response.data.responseEnum;
          if (res === 'OPERATION_SUCCESS') {
            this.setRegistrationInfo(response.data.data.msisdn);
            this.$gtm.trackEvent({
              event: 'CompleteRegistration',
              category: 'MSISDN Registration',
              action: 'Two Step Register 2 registration',
              label: 'Two Step Register 2',
            });
            this.$router.push('twostepregister2');
          } else {
            if (res === 'PIN_EXPIRED') {
              this.message = 'visitor_sign_up_2_pin_expired';
            } else if (res === 'WRONG_PIN') {
              this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
            } else if (res === 'BLOCKED_USER') {
              this.message = 'visitor_forgot_password_warning_msd_max_attempts';
            } else if (res === 'SERVER_ERROR') {
              this.message = 'home_profile_profile_edit_server_unvailable';
            } else if ((res === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (res === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (res === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
              this.message = 'visitor_sign_up_warning_third_party_error';
            } else if (res === 'ALREADY_REGISTERED') {
              this.message = 'visitor_sign_up_msisdn_already_registered';
            }
            this.hasErrors = true;
          }
        });
      } else {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'refUrl',
      'clickid',
      'multiOperatorInfo',
      'maximumDigitsPinLength',
    ]),
    ...mapState('profile', [
      'registrationInfoMsisdn',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/TwoStepRegistration1.vue